import CloseIcon from "@mui/icons-material/Close";
import {
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ASSETS } from "../../utils/config";
import { socialPlatforms } from "../NewBusinessBox/BusinessBoxHelpers";
import "./style.css";
import { isValidUrlNew } from "../../utils/helpers";

const platformValidation = {
  Youtube: (link) => /^(https?\:\/\/)?(www\.)?youtube\.com\/.+$/.test(link),
  Instagram: (link) =>
    /^(https?:\/\/)?(www\.)?instagram\.com\/[A-Za-z0-9_.]+\/?(\?[\w=&]+)?$/i.test(
      link
    ),
  Facebook: (link) =>
    /^(https?:\/\/)?(www\.)?facebook\.com\/[A-Za-z0-9_.]+(\/)?$/i.test(link),
  Tiktok: (link) => /^(https?:\/\/)?(www\.)?tiktok\.com/.test(link),
  Twitter: (link) => /^(https?:\/\/)?(www\.)?twitter\.com/.test(link),
  Linkedin: (link) =>
  /^https(s)?:\/\/([\w]+\.)?linkedin\.com\/(?:in\/[A-z0-9_-]+\/?|company\/[A-z0-9_-]+\/?)$/i.test(link),
};

const AddLinksForm = ({
  setSocialMediaLinks,
  socialLinks,
  setAreLinksValid,
}) => {
  const [links, setLinks] = useState([{ platform: "", link: "" }]);

  const handleLinkChange = (index, field, value) => {
    const newLinks = [...links];
    newLinks[index][field] = value;
    setLinks(newLinks);
    setSocialMediaLinks(newLinks);
  };

  const handleAddLink = () => {
    const id = Math.floor(Date.now() + Math.random());
    setLinks([...links, { id, platform: "", link: "" }]);
  };

  const handleRemoveLink = (link) => {
    var temp = [];
    if (link.id) {
      temp = links.filter((item) => link.id !== item.id);
    } else {
      temp = links.filter((item) => link.platform !== item.platform);
    }
    setLinks(temp);
    setSocialMediaLinks(temp);
  };

  useEffect(() => {
    if (socialLinks) {
      setLinks(socialLinks);
      setSocialMediaLinks(socialLinks);
    }
  }, []);

  useEffect(() => {
    const isValidLinks = validateLinks();
    setAreLinksValid(isValidLinks);
  }, [links]);

  const validateLinks = () => {
    for (let item of links) {
      const { platform, link } = item;
      if (!(platform in platformValidation)) {
        continue;
      }
      if (!platformValidation[platform](link)) {
        return false;
      }
    }
    return true;
  };

  const renderError = (link, platform) => {
    if (platform === "Website") {
      if (isValidUrlNew(link)) {
        return (
          <img
            src={ASSETS.linkSuccess}
            style={{ height: "13px", width: "13px", marginRight: -8 }}
            alt="Ok"
          />
        );
      } else {
        return (
          <img
            src={ASSETS.linkError}
            style={{ height: "13px", width: "13px", marginRight: -8 }}
            alt="Ok"
          />
        );
      }
    } else {
      if (
        platformValidation[platform]
          ? platformValidation[platform](link)
          : false
      ) {
        return (
          <img
            src={ASSETS.linkSuccess}
            style={{ height: "13px", width: "13px", marginRight: -8 }}
            alt="Ok"
          />
        );
      } else {
        return (
          <img
            src={ASSETS.linkError}
            style={{ height: "13px", width: "13px", marginRight: -8 }}
            alt="Ok"
          />
        );
      }
    }
  };

  const existingPlatforms = links.map((link) => link.platform);

  const handleRenderValue = (value) => {
    const selectedOption = socialPlatforms.find((item) => item.name === value);
    return selectedOption ? (
      <>
        <img
          alt="logo"
          src={selectedOption.icon}
          style={{
            height: "12px",
            width: selectedOption.width,
            marginRight: "6px",
            marginTop: "-2px",
          }}
        />
        {selectedOption.name}
      </>
    ) : (
      "Select Platform"
    );
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "10px",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <Typography
          variant="h6"
          style={{
            marginBottom: "6px",
            fontSize: "10px",
            fontFamily: "DM Sans",
          }}
        >
          Add Links
        </Typography>
        <img
          onClick={handleAddLink}
          src={ASSETS.addLink}
          alt="add"
          style={{
            height: "20px",
            width: "20px",
            cursor: "pointer",
          }}
        />
      </div>

      {links.map((link, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "16px",
            gap: "10px",
          }}
        >
          <FormControl
            variant="outlined"
            className="noBorder"
            style={{
              marginRight: "8px",
              width: "80%",
              height: "20px",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Select
                name={`business_link.${index}.platform`}
                style={{
                  height: "20px",
                  fontSize: "8px",
                  border: "none", // This will remove the border
                  outline: "none",
                }}
                renderValue={handleRenderValue}
                value={link.platform || "placeholder"}
                onChange={(e) =>
                  handleLinkChange(index, "platform", e.target.value)
                }
              >
                <MenuItem
                  value="placeholder"
                  style={{ fontSize: "8px", display: "none" }}
                >
                  Select a Platform
                </MenuItem>
                {socialPlatforms
                  .filter(
                    (platform) => !existingPlatforms.includes(platform.name)
                  )
                  .map((platform) => {
                    return (
                      <MenuItem
                        key={platform.name}
                        style={{ fontSize: "8px" }}
                        value={platform.name}
                      >
                        <img
                          alt="logo"
                          src={platform.icon}
                          style={{
                            height: "12px",
                            width: platform.width,
                            marginRight: "3px",
                            marginTop: "-2px",
                          }}
                        />
                        {platform.name}
                      </MenuItem>
                    );
                  })}
              </Select>
            </div>
          </FormControl>

          <TextField
            variant="outlined"
            className="noBorder"
            value={link.link}
            name={`business_link.${index}.link`}
            onChange={(e) => handleLinkChange(index, "link", e.target.value)}
            placeholder="Add Link here"
            fullWidth
            style={{ marginLeft: -20 }}
            InputProps={{
              style: {
                fontSize: "8px",
                height: "20px",
                backgroundColor: "#F6F7F9",
              },
              inputProps: {
                style: {
                  fontSize: "8px",
                  paddingLeft: "8px",
                },
              },
            }}
          />
          {renderError(link.link, link.platform)}
          <CloseIcon
            style={{ width: 12, height: 12, cursor: "pointer" }}
            onClick={() => handleRemoveLink(link)}
          />
        </div>
      ))}
    </div>
  );
};

export default AddLinksForm;
